function mergeObjects(array, commonKey, mergeKey) {
  const seen = new Map();

  return array.filter((e) => {
    let previous;
    const entry = Object(e);

    // Have we seen this label before?
    if (Object.prototype.hasOwnProperty.call(seen, entry[commonKey])) {
      // Yes, grab it and add this data to it
      previous = seen[entry[commonKey]];
      previous[mergeKey].push(entry[mergeKey]);

      // Don't keep this entry, we've merged it into the previous one
      return false;
    }

    // entry.data probably isn't an array; make it one for consistency
    if (!Array.isArray(entry[mergeKey])) {
      entry[mergeKey] = [entry[mergeKey]];
    }

    // Remember that we've seen it
    seen[entry[commonKey]] = entry;

    // Keep this one, we'll merge any others that match into it
    return true;
  });
}

const modifyArray = (arr, transformKey) => arr.map((e) => {
  if (e[transformKey]) {
    return { ...e, [transformKey]: [e[transformKey]] };
  }
  return e;
});

export { mergeObjects, modifyArray };
